/*
 * 海外实名认证相关内容
 * */
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, message, Form, Input, Button } from 'antd';
import Util from '../../../../../script/util';
import HTTP from '../../../../../script/service';
import Scrollbar from 'react-scrollbars-custom';
import CusUpload from '../../../../cusUpload/CusUpload';
import IframeModal from '../../../../iframModal/IframModal';
import './index.scss';

const { TextArea } = Input;

const card_type_list = [
  { id: 21, title: '外国人永久居留身份证(含五星卡)' },
  { id: 22, title: '海外护照' },
  { id: 23, title: '其他证件' },
];

const Abroad = ({ cert, onCancel, onSuccess }) => {
  const { userInfo, rootConfig } = useSelector((store) => store);
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [step, setStep] = useState(null);
  const [checkTypeName, setCheckTypeName] = useState(null);
  const [checkId, setCheckId] = useState(card_type_list[0].id);
  const [isCheckedXy, setIsCheckedXy] = useState(false);
  const [uploadValues, setUploadValues] = useState([]);
  const [uploadShowValues, setUploadShowValues] = useState([]);

  const iframeElement = useRef(null);
  useEffect(() => {
    cert.routeType = cert?.routeType || cert?.certOperateType;
    if (!cert.routeType) {
      cert.routeType =
        cert?.userCertStatus == 1 || cert?.userCertStatus == 4 ? 2 : 0;
    }
    if (cert?.userCertInfoVo) {
      setStep(3);
    } else {
      setStep(2);
    }
  }, [cert]);

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    // 回显
    if (step === 3) {
      if (cert?.userCertInfoVo?.certNo && cert?.userCertInfoVo?.realName) {
        setTimeout(() => {
          form.setFieldsValue({
            realName: cert?.userCertInfoVo.realName,
            certNo: cert?.userCertInfoVo.certNo,
          });
          setUploadValues(cert?.userCertInfoVo?.pics || []);
          setUploadShowValues(cert?.userCertInfoVo?.pics || []);
        }, 200);
      } else {
        setTimeout(() => {
          form.setFieldsValue({
            realName: '',
            certNo: '',
          });
          setUploadValues([]);
          setUploadShowValues([]);
        }, 200);
      }
    }
  }, [step]);

  const onStep = (type) => {
    if (type == 1) {
      setStep(1);
    } else if (type == 2) {
      setStep(2);
    } else if (type == 3) {
      if (!checkId) {
        message.error('请选择您的证件类型');
        return;
      }
      if (!isCheckedXy) {
        message.error('请阅读并同意《实名认证服务协议》');
        return;
      }
      setStep(3);
      setCheckTypeName(card_type_list.find((e) => e.id == checkId)?.title);
    }
  };

  //撤销
  const cancelSubmit = (e) => {
    e.preventDefault();
    let params = {
      uid: userInfo.uid,
    };
    HTTP._user_real_recall(params).then((res) => {
      if (res.code == 200) {
        onSuccess && onSuccess();
        setStep(null);
        message.success('撤销成功');
        dispatch({ type: 'risk_auth_data', data: { riskAuthData: null } });
      } else {
        message.error(res.message || '操作失败，请稍后重试');
      }
    });
  };

  //提交
  const handleSubmit = (values) => {
    const params = {
      uid: userInfo.uid,
      ...values,
      certPics: uploadValues.join(','),
      certOperateType: cert?.routeType ?? cert?.certOperateType,
      sceneType: cert.sceneType,
    };
    if (!cert?.certifyTypeName) {
      params.certifyType = checkId;
    }
    if (uploadValues.length == 0) {
      message.error('请上传证件照');
      return;
    }

    HTTP._v4_hk_realNameCertAuth(params).then((res) => {
      if (res.code == 200) {
        onSuccess && onSuccess();
        setStep(null);
        message.success('提交成功');
        dispatch({ type: 'risk_auth_data', data: { riskAuthData: null } });
      } else {
        message.error(res.message || '操作失败，请稍后重试');
      }
    });
  };
  const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  // 上传图片
  const uploadIdentityImg = async (res, info) => {
    if (res) {
      setUploadValues([...uploadValues, res.default]);
      let file = !info?.file?.originFileObj
        ? await getBase64(info.file.originFileObj)
        : res.defaultViewPrivateUrl;
      setUploadShowValues([...uploadShowValues, file]);
    }
  };
  // 删除图片
  const delPic = (index) => {
    let arr = uploadValues.filter((e, i) => i !== index);
    let arr2 = uploadShowValues.filter((e, i) => i !== index);
    setUploadValues(arr);
    setUploadShowValues(arr2);
  };

  // 打开协议
  const openXieyi = (url) => {
    const mobilePath = rootConfig?.protocolPath || rootConfig.mobilePath;
    let modalurl = mobilePath + url + '?v=' + rootConfig.version;
    iframeElement.current.showModal(modalurl, { zIndex: 1009 });
  };

  const onClose = () => {
    setStep(null);
    onCancel && onCancel();
  };

  //弹窗1
  const renderModal1 = () => {
    return (
      <Modal
        destroyOnHidden={true}
        footer={null}
        centered={true}
        open={true}
        className="daidai-modal-style has-top-border hk-real-container"
        width="400px"
        title={'海外用户信息认证'}
        onCancel={onClose}
        maskClosable={false}
        zIndex={1009}
      >
        <div className="hk-real-body">
          <div className="real-tip-icon" />
          <div className="real-form ">
            <p className="real-tip-text">
              为提升您的账号安全等级，需进行账号人脸认证，确保账号是您本人操作，防止账号被非法盗用及违规使用。
            </p>
            <div className="form-btns flex" style={{ marginTop: '24px' }}>
              <button className="daidai-btn-cancel" onClick={onClose}>
                残忍拒绝
              </button>
              <button className="daidai-btn-primary" onClick={() => setStep(2)}>
                去实名
              </button>
            </div>
          </div>
        </div>
      </Modal>
    );
  };
  //弹窗2
  const renderModal2 = () => {
    return (
      <Modal
        destroyOnHidden={true}
        footer={null}
        centered={true}
        open={true}
        className="daidai-modal-style has-top-border hk-real-container"
        width="400px"
        title={'海外用户信息认证'}
        onCancel={onClose}
        maskClosable={false}
        zIndex={1009}
      >
        <div className="hk-real-body">
          <div className="real-tip-icon" />
          <div className="real-form ">
            <p className="real-tip-text">
              应国家法律法规要求，响应未成年人保护号召，进行该操作需进行账号实名，保障账号安全，防止账号被非法盗用或违规使用。
            </p>

            <p className="real-tip-text">请选择您的证件类型：</p>
            <div className="real-form-check-wrap">
              <div
                className={`real-form-check ${checkId == 21 ? 'active' : ''}`}
                onClick={() => setCheckId(21)}
              >
                <span>外国人永久居留身份证(含五星卡)</span>
                <i className="icon-check"></i>
              </div>
              <div
                className={`real-form-check ${checkId == 22 ? 'active' : ''}`}
                onClick={() => setCheckId(22)}
              >
                <span>海外护照</span>
                <i className="icon-check"></i>
              </div>
              <div
                className={`real-form-check ${checkId == 23 ? 'active' : ''}`}
                onClick={() => setCheckId(23)}
              >
                <span>其他证件</span>
                <i className="icon-check"></i>
              </div>
            </div>
            <p
              className="real-tip-text"
              style={{ fontSize: '12px', color: '#FF6E94' }}
            >
              注意：实名认证信息与账号使用主体具有一致性，认证后不可修改
            </p>
            <div className="form-btns" style={{ margin: '12px auto' }}>
              <button className="daidai-btn-primary" onClick={() => onStep(3)}>
                同意协议并认证
              </button>
              <div className="checkbox">
                <label onClick={() => setIsCheckedXy(!isCheckedXy)}>
                  <i
                    className={`icon-checkbox ${isCheckedXy ? 'active' : ''}`}
                  ></i>
                  已阅读并同意
                </label>
                <span
                  style={{ color: '#fff' }}
                  onClick={() => openXieyi('/realname/index.html')}
                >
                  《实名认证服务协议》
                </span>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  };
  //弹窗3
  const renderModal3 = () => {
    const uploadHeader = {
      authorization: userInfo.accessToken,
      uid: userInfo.uid,
    };
    return (
      <Modal
        destroyOnHidden={true}
        footer={null}
        centered={true}
        open={true}
        className="daidai-modal-style has-top-border hk-real-container"
        width="560px"
        title={'海外用户信息认证'}
        onCancel={onClose}
        maskClosable={false}
        zIndex={1009}
      >
        <div className="hk-real-body">
          <div className="real-form-tip">
            {cert?.userCertStatus == 3 || cert?.userCertStatus == 4 ? (
              <>
                <p>信息正在审核中，请耐心等待审核结果。</p>
                <p>等待过程中，您的部分功能将被限制使用。</p>
              </>
            ) : cert?.routeType == 1 || cert?.routeType == 2 ? (
              <>
                <p>尊敬的用户：</p>
                <p>
                  检测到您的账号存在安全隐患，请上传您的手持证件照片以验证身份。
                </p>
              </>
            ) : (
              <p>
                填写并上传对应信息，由工作人员进行审核，您在实名认证信息通过后，能正常使用对应功能。
                个人信息仅用于实名认证，平台会严格保密您的个人信息。
              </p>
            )}
          </div>
          <Form
            form={form}
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 18 }}
            className="real-form"
            onFinish={handleSubmit}
          >
            <Scrollbar
              className="my-scroll-bar"
              style={{
                height:
                  cert?.routeType == 1 || cert?.routeType == 2
                    ? '550px'
                    : '520px',
              }}
            >
              <div className="real-form-tit t1">账号信息确认</div>
              <div className="real-form-block">
                <div className="real-form-basic">
                  <div className="real-form-basic-avatar">
                    <div className="real-form-basic-cover">
                      <img
                        src={Util.transImgUrl(userInfo?.avatar, '150x150')}
                        alt=""
                      />
                    </div>
                    <div className="real-form-basic-name">
                      <p>{userInfo.nickname}</p>
                      <p>UID：{userInfo.uid}</p>
                    </div>
                  </div>
                  <div className="real-form-basic-type">
                    <div className="real-form-label">证件类型：</div>
                    <div className="real-form-text">
                      {cert?.userCertInfoVo?.certifyTypeName || checkTypeName}
                    </div>
                  </div>
                </div>
              </div>
              {cert?.userCertStatus == 3 || cert?.userCertStatus == 4 ? (
                <div className="real-form-tit t2">
                  <i className="icon-jin"></i>信息正在审核中，请耐心等待：
                </div>
              ) : (
                <div className="real-form-tit t2">
                  <i className="icon-jin"></i>
                  {cert?.routeType == 1 || cert?.routeType == 2
                    ? '请上传手持证件照片'
                    : '请认真填写以下信息，认证成功后，实名信息将无法修改：'}
                </div>
              )}
              <div className="real-form-block">
                <Form.Item
                  className="real-form-row"
                  label="姓名"
                  name="realName"
                  rules={[
                    {
                      required: cert?.routeType != 2 ? true : false,
                      message: '请填写和证件上一致的姓名',
                    },
                  ]}
                >
                  <Input
                    className="real-form-input"
                    disabled={cert?.routeType == 2}
                    placeholder="请填写和证件上一致的姓名"
                    autoComplete="off"
                  />
                </Form.Item>
                <Form.Item
                  className="real-form-row"
                  label="证件号"
                  name="certNo"
                  rules={[
                    {
                      required: cert?.routeType != 2 ? true : false,
                      message: '请填写正确的证件号码',
                    },
                  ]}
                >
                  <Input
                    className="real-form-input"
                    disabled={cert?.routeType == 2}
                    placeholder="请填写正确的证件号码"
                    autoComplete="off"
                  />
                </Form.Item>
              </div>
              <div className="real-form-block">
                <div className="real-form-row">
                  <span className="real-form-label">
                    {cert?.userCertStatus != 3 && cert?.userCertStatus != 4 ? (
                      <em>*</em>
                    ) : null}
                    {cert?.routeType == 1 || cert?.routeType == 2
                      ? '手持证件照'
                      : '证件照'}
                  </span>
                </div>
                <div className="real-form-pic-wrap">
                  {cert?.userCertStatus != 3 &&
                    cert?.userCertStatus != 4 &&
                    uploadShowValues?.length < 9 && (
                      <div className="real-form-pic-item add">
                        <CusUpload
                          size={2}
                          privateType={1}
                          onChange={uploadIdentityImg}
                          headers={uploadHeader}
                        >
                          <div className="icon-add"></div>
                        </CusUpload>
                      </div>
                    )}
                  {uploadShowValues?.length > 0 &&
                    uploadShowValues.map((item, index) => (
                      <div className="real-form-pic-item" key={index}>
                        {cert?.userCertStatus != 3 &&
                          cert?.userCertStatus != 4 && (
                            <div
                              className="real-form-pic-close"
                              onClick={() => delPic(index)}
                            ></div>
                          )}
                        <img src={Util.transImgUrl(item)} alt="" />
                      </div>
                    ))}
                </div>
                {cert?.userCertStatus != 3 && cert?.userCertStatus != 4 && (
                  <ul className="real-form-ul">
                    <li>1.最多上传9张；</li>
                    <li>
                      2.必须上传带有
                      <span style={{ color: '#FF4279' }}>
                        {cert?.routeType == 1 || cert?.routeType == 2
                          ? '用户手持证件'
                          : '人像的证件照'}
                      </span>
                      ；
                    </li>
                    <li>3.建议上传清晰的内容，提高审核通过率。</li>
                  </ul>
                )}
              </div>
              {cert?.userCertStatus != 3 && cert?.userCertStatus != 4 && (
                <div className="real-form-block" style={{ marginBottom: 0 }}>
                  <div className="real-form-row">
                    <span className="real-form-label">备注</span>
                  </div>
                  <Form.Item
                    wrapperCol={{ span: 24 }}
                    className="real-form-row"
                    name="remark"
                    label=""
                  >
                    <TextArea
                      className="real-form-textarea"
                      placeholder="请填写需要审核人员注意的事项，如没有可不填。"
                      autoComplete="off"
                    />
                  </Form.Item>
                </div>
              )}
            </Scrollbar>
            <div className="form-btns flex" style={{ marginTop: '20px' }}>
              {cert?.userCertStatus == 3 || cert?.userCertStatus == 4 ? (
                <>
                  <Button
                    className="daidai-btn-primary"
                    onClick={(e) => cancelSubmit(e)}
                  >
                    撤销审核
                  </Button>
                  <Button className="daidai-btn-primary disabled">
                    平台审核中
                  </Button>{' '}
                </>
              ) : (
                <Button className="daidai-btn-primary" htmlType="submit">
                  提交审核
                </Button>
              )}
            </div>
          </Form>
        </div>
      </Modal>
    );
  };
  return (
    <>
      {step == 1 && renderModal1()}
      {step == 2 && renderModal2()}
      {step == 3 && renderModal3()}
      {/* H5弹窗 */}
      <IframeModal wrappedComponentRef={iframeElement} />
    </>
  );
};
export default Abroad;
